var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card"},[_c('card-m',{attrs:{"title":"资料详情进度","cardWidth":"97%","cardHeight":"97%","maxHeight":"100%"}},[_c('template',{slot:"card-box"},[_c('cardTable',{attrs:{"total":_vm.totalCounts,"tableColumn":_vm.column,"tableData":_vm.tableData,"loading":_vm.loading,"showPaging":false}})],1)],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }